import { AHText, AHTextFonts, AHTextProps } from "../Text";
import { StyleProp, TextStyle, ViewStyle } from "react-native";

import { Box } from "../AHTheme/Box";
import React from "react";
import { useScaleFactor } from "../AHScaleFactor";
import { Space } from "../LayoutProvider";
import { useWidgetOptions } from "./WidgetOptionsContext";

export const useWidgetTitleHeight = () => {
  return 25 * useScaleFactor();
};

export const AHWidgetTitleText = ({
  color,
  enableTextShadow,
  style,
  ...rest
}: {
  style?: StyleProp<TextStyle>;
  enableTextShadow?: boolean;
} & AHTextProps) => {
  return (
    <AHText
      type="subtitle"
      allowFontScaling={false}
      spaceHorizontal="small"
      color={color ?? "darkerText"}
      font={AHTextFonts.BOLDER}
      style={[
        enableTextShadow
          ? {
              backgroundColor: "transparent",
              textShadowOffset: { width: 0, height: 0 },
              textShadowRadius: 3,
              textShadowColor: "black",
            }
          : undefined,

        style,
      ]}
      numberOfLines={1}
      {...rest}
    />
  );
};
const AHWidgetTitleC = ({
  color,
  enableTextShadow,
  style,
  ...rest
}: {
  style?: StyleProp<TextStyle>;
  enableTextShadow?: boolean;
} & AHTextProps) => {
  const height = useWidgetTitleHeight();
  const { headerRight } = useWidgetOptions();
  return (
    <Box
      spaceRight={headerRight ? "small" : undefined}
      style={{
        flexDirection: "row",
        height,
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <AHWidgetTitleText
        color={color}
        enableTextShadow={enableTextShadow}
        style={[headerRight ? { flexShrink: 1 } : undefined, style]}
        {...rest}
      />
      {headerRight}
    </Box>
  );
};
export const AHWidgetTitle = React.memo(AHWidgetTitleC);

export const AHWidgetTitleWrapper = (props: {
  children: React.ReactNode;
  spaceHorizontal?: Space;
  spaceTop?: Space;
  style?: StyleProp<ViewStyle>;
}) => {
  const height = useWidgetTitleHeight();
  return (
    <Box
      spaceHorizontal={props.spaceHorizontal ?? "medium"}
      style={[
        {
          flexDirection: "row",
          height,
          justifyContent: "space-between",
          alignItems: "center",
        },
        props.style,
      ]}
    >
      {props.children}
    </Box>
  );
};
